import {hexToRgba} from '#util/hexToRgba';

export const colorValues = {
  // BRAND COLORS
  apricot: '#FF6E4A',
  burgundy: '#731445',
  deepBurgundy: '#4A0C33',
  eggplant: '#D93359',
  eggplantDark: '#9C2147',
  grapefruit: '#FF3D5E',
  orange: '#EB4500',
  paleOrange: '#FFD7C3',
  peach: '#FFB087',
  pink: '#FF7C87',
  tangerine: '#FF9170',
  lemon: '#FFBF42',
  crimson: '#CC3A47',
  yellowBlonde: '#FFDE87',

  // NEUTRAL COLORS
  black: '#000000',
  concrete: '#F2F2F2',
  cotton: '#FFFEF8',
  doveGray: '#666666',
  dustyGray: '#999999',
  ecruWhite: '#FAF9F2',
  mineShaft: '#333333',
  midnight: '#0D2950',
  moonMist: '#E2E2D6',
  silver: '#CCCCCC',
  springWood: '#F4F4EB',
  white: '#FFFFFF',

  // UTILITY COLORS
  faintRed: '#FEEBEB',
  solidRed: '#ED0505',
  solidGreen: '#49A97A',
} as const;

export const colorNames = {
  // CSS keywords.
  currentColor: 'currentColor',
  inherit: 'inherit',
  transparent: 'transparent',
} as const;

export const gradients = {
  // Gradients
  progressGradient:
    'linear-gradient(90deg, #EB4500 0%, #FF8570 18.85%, #FF9D80 39.26%, #FC7F7F 59.53%, #D7355A 79.8%, #731445 100%)',
  backgroundGradient: `linear-gradient(318.57deg, rgba(238, 144, 112, 0.5) -1.76%, rgba(250, 225, 183, 0.382812) 27.59%, rgba(255, 255, 249, 0) 67.8%),  ${colorValues.cotton}`,
  backgroundGradientBurgundy: `
          radial-gradient(110.09% 100.89% at 53.75% 98.35%,
            ${hexToRgba(colorValues.eggplant, 0.5)} 0%,
            ${hexToRgba(colorValues.eggplant, 0)} 100%
          ),
          linear-gradient(319.77deg, ${colorValues.burgundy} -15.72%, ${
    colorValues.deepBurgundy
  } 103.87%)`,
};

export const colors = {
  ...colorValues,
  ...colorNames,
  ...gradients,
};
